import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import _ from 'lodash';

export default function riskFactorReducer(state = initialstate.riskFactors, action) {
	switch (action.type) {
		case types.GET_RISKS_FACTORS:
			return action.response || state;
		case types.UPDATE_RISK_FACTOR_RELATION:
			let newState = _.cloneDeep(state);

			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let updatedRiskFactorRelation = newState.find((riskFactor) => riskFactor.id === action.riskFactorRelationId);
				if (updatedRiskFactorRelation) {
					updatedRiskFactorRelation.riskId = action.response.riskId;
					updatedRiskFactorRelation.rationale = action.response.rationale;
					updatedRiskFactorRelation.isNotMaterial = action.response.isNotMaterial;
				}
			}
			return newState;
		default:
			return state;
	}
}

/*
 Group Risk Factors  by Form Header.
 */
export function groupRiskFactorByFormHeader(riskFactors) {
	let riskFactorByFormHeaders = {};
	if (riskFactors && riskFactors.length > 0) {
		riskFactorByFormHeaders = _.chain(riskFactors)
			// Group the elements of Array based on `form headerid` property
			.groupBy('formHeaderName')
			// `key` is group's name (risk type id), `value` is the array of objects (risks)
			.map((value, key) => ({
				formHeaderId: value[0].formHeaderId,
				riskFactors: value,
				formHeaderName: value[0].formHeaderName,
				taskDisplayOrder: value[0].taskDisplayOrder,
				taskShortName: value[0].taskShortName
			}))
			.value();
	}
	var orderedRiskFactorResult = _.orderBy(riskFactorByFormHeaders, ['taskDisplayOrder'], ['asc']);
	return orderedRiskFactorResult;
}
